<div class="cs-intro-container">
	<div class="intro-title">{{ data.title | translate }}</div>
	<div class="intro-items-container">	
		@for (item of data.items; track item) {
			<div class="intro-item">
				<div class="intro-item__image">
					<img
						class="img-responsive"
						[src]="item.src"
						[alt]="item.alt" />
				</div>
				<div class="intro-item__texts">
					<div class="intro-item__texts__title">
						{{ item.title | translate }}
					</div>
					<div class="intro-item__texts__info">
						{{ item.description | translate }}
					</div>
				</div>
			</div>
		}
	</div>
</div>